import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  PromotionCheckboxContainer,
  PromotionCheckboxLabel,
  PromotionCheckboxPrice,
  PromotionCheckboxWrapper,
} from '../styles/PromotionCheckbox.styles';
import BodyCopy from '../../../../../atoms/BodyCopy';
import Checkbox from '../../../atoms/Checkbox/Checkbox';
import { getCouponDetails } from '../../../../../../../utils/utils.web';
import { renderLabel, getDynamicLabelValues } from '../../../../../../../utils/labels/labelUtilty';

const PromotionCheckbox = ({
  coupon,
  applyCoupon,
  removeCoupon,
  isApplied,
  updateCheckbox,
  isOptimizedApplyCouponEnabled,
}) => {
  const [checked, setChecked] = useState(isApplied);
  const [isPristine, setIsPristine] = useState(true);
  if (!coupon) return null;

  const { price, promotionMessage, code, couponCode, customPromotionMessagePDP, promoCouponCode } =
    getCouponDetails(coupon);
  const [couponBody] = promotionMessage?.split(',');
  let couponText = `Apply ${couponBody.toLowerCase()} coupon | ${couponBody} ${code}`;
  let updatedCouponCode = couponCode;

  if (isOptimizedApplyCouponEnabled) {
    couponText = customPromotionMessagePDP;
    updatedCouponCode = promoCouponCode;
  }

  const appliedDiscountText = renderLabel(
    getDynamicLabelValues(`dynamic.browse_d.lbl_applied_discount_at_checkout`)
  );

  const handleChange = (e) => {
    e.preventDefault();
    setChecked(!checked);
    setIsPristine(false);
  };

  useEffect(() => {
    if (!isPristine) {
      if (checked) {
        applyCoupon(updatedCouponCode);
      } else {
        removeCoupon(updatedCouponCode);
      }
    }
  }, [checked]);

  useEffect(() => {
    setChecked(isApplied);
  }, [isApplied, updateCheckbox]);

  return (
    <PromotionCheckboxContainer>
      <PromotionCheckboxPrice>
        <BodyCopy
          fontSizeVariation="medium"
          color="white"
          fontSize="fs20"
          fontFamily="secondary"
          fontWeight="extrabold"
        >
          ${price}
        </BodyCopy>
      </PromotionCheckboxPrice>
      <PromotionCheckboxWrapper>
        <Checkbox checked={checked} handleChange={handleChange} overrideCheckBoxColor="GREEN" />
        <PromotionCheckboxLabel
          fontFamily="secondary"
          color="green.500"
          fontSize="fs14"
          fontWeight="semibold"
        >
          {checked ? appliedDiscountText : couponText}
        </PromotionCheckboxLabel>
      </PromotionCheckboxWrapper>
    </PromotionCheckboxContainer>
  );
};

export default React.memo(PromotionCheckbox);

PromotionCheckbox.propTypes = {
  coupon: PropTypes.shape({}),
  applyCoupon: PropTypes.func,
  removeCoupon: PropTypes.func,
  isApplied: PropTypes.bool,
  updateCheckbox: PropTypes.bool,
  isOptimizedApplyCouponEnabled: PropTypes.bool,
};

PromotionCheckbox.defaultProps = {
  coupon: null,
  applyCoupon: () => {},
  removeCoupon: () => {},
  isApplied: false,
  updateCheckbox: false,
  isOptimizedApplyCouponEnabled: false,
};
